module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG404528b19ff09903fd2de48d606ce142.404528b1.png";